export { PickupMethod } from '@wix/ambassador-gateways-ecom-v1-delivery-rates-gateway/types';
export let ComponentState = /*#__PURE__*/function (ComponentState) {
  ComponentState["READY"] = "Ready";
  ComponentState["LOADING"] = "Loading";
  ComponentState["INVALID"] = "Invalid";
  return ComponentState;
}({});
export let DisplayState = /*#__PURE__*/function (DisplayState) {
  DisplayState["HIDDEN"] = "Hidden";
  DisplayState["EDITABLE"] = "Editable";
  DisplayState["READ_ONLY"] = "ReadOnly";
  return DisplayState;
}({});
export let DeliveryMethodsSection = /*#__PURE__*/function (DeliveryMethodsSection) {
  DeliveryMethodsSection["DELIVERY"] = "delivery";
  DeliveryMethodsSection["PICKUP"] = "pickup";
  return DeliveryMethodsSection;
}({});
//# sourceMappingURL=types.js.map